export enum ThirdPartyStatus {
  Active = 'active',
  Archived = 'archived',
  PreContract = 'pre_contract',
  ReviewDue = 'review_due',
}
